var _circle, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 50.5,
    transform: "matrix(-1 0 0 1 125 25)",
    fill: "#FF5F00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 55.5,
    cy: 55.5,
    r: 54,
    transform: "matrix(-1 0 0 1 130 20)",
    stroke: "#FF5F00",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9653 81.5506L66.8416 49.3333C66.7855 48.8939 66.7574 48.3171 66.7574 47.603C66.7574 43.8677 68.7211 42 72.6485 42H76.2673C80.2508 42 82.2426 43.8677 82.2426 47.603C82.2426 47.8777 82.1865 48.4544 82.0743 49.3333L77.8663 81.5506H70.9653ZM83 99.8427C83 102.26 82.2145 104.237 80.6436 105.775C79.0726 107.258 76.9967 108 74.4158 108C71.8911 108 69.8432 107.258 68.2723 105.775C66.7574 104.237 66 102.26 66 99.8427C66 97.3708 66.7574 95.3933 68.2723 93.9101C69.8432 92.427 71.8911 91.6854 74.4158 91.6854C76.9967 91.6854 79.0726 92.427 80.6436 93.9101C82.2145 95.3933 83 97.3708 83 99.8427Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1193,
    cy: 19.0999,
    r: 5.9129,
    fill: "#FF5F00"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1968,
    cy: 16.3709,
    r: 3.18387,
    fill: "#FF5F00"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.829,
    cy: 40.9324,
    r: 3.18387,
    fill: "#FF5F00"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5484,
    cy: 73.2256,
    r: 4.54839,
    fill: "#FF5F00"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8226,
    cy: 113.706,
    r: 3.18387,
    fill: "#FF5F00"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9226,
    cy: 134.174,
    r: 4.54839,
    fill: "#FF5F00"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.0322,
    cy: 136.903,
    r: 1.81935,
    fill: "#FF5F00"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.1387,
    cy: 141.907,
    r: 4.09355,
    fill: "#FF5F00"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.606,
    cy: 135.994,
    r: 2.72903,
    fill: "#FF5F00"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.623,
    cy: 125.532,
    r: 4.09355,
    fill: "#FF5F00"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.99,
    cy: 106.429,
    r: 2.27419,
    fill: "#FF5F00"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.177,
    cy: 89.1453,
    r: 2.27419,
    fill: "#FF5F00"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.903,
    cy: 55.0323,
    r: 4.54839,
    fill: "#FF5F00"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.168,
    cy: 49.5742,
    r: 2.72903,
    fill: "#FF5F00"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.245,
    cy: 25.0127,
    r: 2.72903,
    fill: "#FF5F00"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.7742,
    cy: 7.72903,
    r: 2.72903,
    fill: "#FF5F00"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.529,
    cy: 18.6451,
    r: 4.54839,
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c3bc61c6cb43e4c226ae6e1a9d399e72.svg";
export { ForwardRef as ReactComponent };